var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fib-button',{staticClass:"back-btn bg-white",attrs:{"round":"","outline":""},on:{"click":_vm.handleClick}},[_c('fib-svg',{attrs:{"margin":"0 auto","src":"statics/icons/back.svg","width":"24px","height":"24px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }